import { useState } from 'react'
import { handleContactAction } from '../utils/contactActions'

const COPIED_RESET_MS = 1500

const useContactCopy = (resetMs = COPIED_RESET_MS) => {
	const [copiedIndex, setCopiedIndex] = useState(-1)

	const handleContactClick = (contact, index) => {
		const copied = handleContactAction(contact)
		if (copied) {
			setCopiedIndex(index)
			setTimeout(() => setCopiedIndex(-1), resetMs)
		}
	}

	return { copiedIndex, handleContactClick }
}

export default useContactCopy
